import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/shared/Modal.css';

const AdminDetailModal = ({
  show,
  onClose,
  title,
  subtitle,
  icon,
  summary,
  children,
  footer,
  size = 'lg',
  dialogClassName = 'admin-modal admin-detail-modal',
}) => (
  <Modal show={show} onHide={onClose} centered size={size} dialogClassName={dialogClassName}>
    <Modal.Header closeButton>
      <Modal.Title>
        {icon ? <FontAwesomeIcon icon={icon} /> : null}
        <span>{title}</span>
      </Modal.Title>
      {subtitle ? <p className="admin-modal-subtitle">{subtitle}</p> : null}
    </Modal.Header>
    <Modal.Body>
      <div className="admin-modal-shell admin-detail-modal-shell">
        {summary ? <div className="admin-detail-summary">{summary}</div> : null}
        {children}
      </div>
    </Modal.Body>
    {footer ? <Modal.Footer>{footer}</Modal.Footer> : null}
  </Modal>
);

export default AdminDetailModal;
